module.exports = __webpack_public_path__ + "static/media/usb-a-silver.15f6fcb4.svg";